export default __webpack_public_path__ + "static/media/ExpressJS.6a3e055a.png";